export const simpleOptions = new Array(6).fill(null).map((_, i) => {
    return i === 4
        ? { divider: true }
        : {
            id: `${i}`,
            value: `Input Text ${i + 1}`,
            isSelectable: i < 3,
        };
});
export const optionsWithSubtitle = simpleOptions.map((option, i) => ({
    ...option,
    subtitle: i === 0
        ? `The longest subtitle has 2 lines. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.`
        : `Subtitle Text ${i}`,
}));
export const optionsWithUnavailableItems = [
    {
        id: '0',
        value: 'Site Pages (selectable)',
        isSelectable: true,
    },
    {
        id: '1',
        value: 'Home (not selectable)',
        isSelectable: false,
    },
    {
        id: '2',
        value: 'Shop (unavailable)',
        unavailable: true,
    },
];
export const optionsWithIcon = `[{
    id: '1',
    value: 'Share 01',
    isSelectable: true,
    icon: <Icons.Share />
}, {
    id: '2',
    value: 'Share 02',
    isSelectable: true,
    icon: <Icons.Share />
}]`;
export const optionsWithIconAndSubtitles = `[{
    id: '1',
    value: 'Share 01',
    subtitle: 'Subtitle Share 01',
    isSelectable: true,
    icon: <Icons.Share />
}, {
    id: '2',
    value: 'Share 02',
    subtitle: 'Subtitle Share 02',
    isSelectable: true,
    icon: <Icons.Share />
}]`;
export const optionsWithSuffix = `[{
    id: '1',
    value: 'Share 01',
    subtitle: 'Subtitle Share 01',
    isSelectable: true,
    suffix: <Counter />
}, {
    id: '2',
    value: 'Share 02',
    subtitle: 'Subtitle Share 02',
    isSelectable: true,
    suffix: <Counter />
}]`;
export const optionsWithSections = [
    {
        id: '0',
        value: 'Site Pages',
        isSectionTitle: true,
        isSelectable: false,
    },
    {
        id: '1',
        value: 'Home',
        isSelectable: true,
    },
    {
        id: '2',
        value: 'Shop',
        isSelectable: true,
    },
    {
        id: '3',
        value: 'About',
        isSelectable: true,
    },
    {
        id: '4',
        value: 'Blog Posts',
        isSectionTitle: true,
        isSelectable: false,
    },
    {
        id: '5',
        value: '11 Proven Ways to Monetize a Website',
        isSelectable: true,
    },
];
export const numberOptions = new Array(6).fill(null).map((_, i) => ({
    id: `${i}`,
    value: `0${i + 1}`,
    isSelectable: true,
}));
export const modifyOptions = (options) => {
    return options.map((option) => option.unavailable
        ? {
            ...option,
            // Should internally add the `isSelectable` property to the item (needed by the wix-ui-core dropdown in order to trigger the onClick event)
            isSelectable: option.isSelectable === undefined ? true : option.isSelectable,
        }
        : option);
};
export const optionsWithTextWrap = [
    {
        id: '0',
        value: 'Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1',
        isSelectable: true,
        textOverflow: 'wrap',
    },
    { id: '1', value: 'Input Text 2', isSelectable: true, textOverflow: 'wrap' },
];
export const optionsWithTextEllipsis = [
    {
        id: '0',
        value: 'Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1Input Text 1',
        isSelectable: true,
        textOverflow: 'ellipsis',
    },
    {
        id: '1',
        value: 'Input Text 2',
        isSelectable: true,
        textOverflow: 'ellipsis',
    },
];
//# sourceMappingURL=helpers.js.map